import { render, staticRenderFns } from "./Interviews.vue?vue&type=template&id=65db9142&scoped=true"
import script from "./Interviews.vue?vue&type=script&lang=js"
export * from "./Interviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65db9142",
  null
  
)

export default component.exports